const parseScopes = (rawScopes) =>
  rawScopes
    .split(",")
    .map((scope) => scope.trim())
    .filter(Boolean);

export const appConfig = {
  oktaIssuer: process.env.REACT_APP_OKTA_ISSUER || "",
  oktaClientId: process.env.REACT_APP_OKTA_CLIENT_ID || "",
  oktaScopes: parseScopes(process.env.REACT_APP_OKTA_SCOPES || "openid,profile,email"),
  specReviewUrl:
    process.env.REACT_APP_SPEC_REVIEW_URL ||
    "https://api-governance-dev.fceks-useast1-1.int.platform.security.cisco.com/v1/spec-review",
};

export const isOktaConfigured = Boolean(appConfig.oktaIssuer && appConfig.oktaClientId);
